var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ab-video",class:{
    'ab-video_fit': _setup.containerSizeVal,
  }},[(_setup.videoId)?_c(_setup.AbRichVideo,{attrs:{"id":_setup.videoId,"container-size":_setup.containerSizeVal,"autoplay":_setup.autoplayVal}}):(_setup.videoSrc)?_c('video',{ref:"video",class:[
      _setup.videoClassVal,
      {
        'ab-video__video_fit': _setup.containerSizeVal,
      },
    ],attrs:{"playsinline":"","loop":_setup.loopVal,"controls":_setup.controlsVal,"autoplay":_setup.autoplayVal},domProps:{"muted":_setup.mutedVal}},[_c('source',{attrs:{"src":_setup.videoSrc}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }